module.exports = __webpack_public_path__ + "static/media/22.818b00b9.JPG";